import { useEffect, useRef } from 'react';
import { useOnboardingStore } from '../onboardingStore';

/**
 * Main orchestration hook for the onboarding system.
 * Triggers the welcome modal on first visit after a short delay.
 */
export function useOnboarding() {
  const hasCompletedWelcome = useOnboardingStore((s) => s.hasCompletedWelcome);
  const isWelcomeOpen = useOnboardingStore((s) => s.isWelcomeOpen);
  const hasTriggered = useRef(false);

  useEffect(() => {
    // Show welcome modal on first visit after 500ms delay
    if (!hasCompletedWelcome && !isWelcomeOpen && !hasTriggered.current) {
      hasTriggered.current = true;
      const timer = setTimeout(() => {
        useOnboardingStore.getState().openWelcome();
      }, 500);
      return () => { clearTimeout(timer); };
    }
    return undefined;
  }, [hasCompletedWelcome, isWelcomeOpen]);
}
